import { createFeatureSelector, createSelector } from "@ngrx/store";
import { RootState } from "src/app/root-store/root-state";
import { KwikspaceStoreState } from "../state";

export const featureKey = "kwikspaceApp";

const getKwikspaceAppState = createFeatureSelector<RootState, KwikspaceStoreState>(
  featureKey
);

export const getRentalPriceList = createSelector(
  getKwikspaceAppState,
  (state) => state.rental.rentals
);

export const getRentalPriceListLoading = createSelector(
  getKwikspaceAppState,
  (state) => state.rental.rentalsLoading
);

export const getRentalPriceListError = createSelector(
  getKwikspaceAppState,
  (state) => state.rental.rentalsError
);

export const getRentalCategoryList = createSelector(
  getKwikspaceAppState,
  (state) => state.rental.rentalCategory
);

export const getRentalCategoryLoading = createSelector(
  getKwikspaceAppState,
  (state) => state.rental.rentalCategoryLoading
);

export const getRentalCategoryError = createSelector(
  getKwikspaceAppState,
  (state) => state.rental.rentalCategoryError
);

export const getRentalCategorySizeList = createSelector(
  getKwikspaceAppState,
  (state) => state.rental.rentalCategorySize
);

export const getRentalCategorySizeLoading = createSelector(
  getKwikspaceAppState,
  (state) => state.rental.rentalCategorySizeLoading
);

export const getRentalCategorySizeError = createSelector(
  getKwikspaceAppState,
  (state) => state.rental.rentalCategorySizeError
);

export const getRentalSizes = createSelector(
  getKwikspaceAppState,
  (state) => state.rental.rentalSizes
);

export const getRentalSizesLoading = createSelector(
  getKwikspaceAppState,
  (state) => state.rental.rentalSizesLoading
);

export const getRentalSizesError = createSelector(
  getKwikspaceAppState,
  (state) => state.rental.rentalSizesError
);

export const getRentalPeriods = createSelector(
  getKwikspaceAppState,
  (state) => state.rental.rentalPeriods
);

export const getRentalPeriodsLoading = createSelector(
  getKwikspaceAppState,
  (state) => state.rental.rentalPeriodsLoading
);

export const getRentalPeriodsError = createSelector(
  getKwikspaceAppState,
  (state) => state.rental.rentalPeriodsError
);

export const getRentalOptions = createSelector(
  getKwikspaceAppState,
  (state) => state.rental.rentalOptions
);

export const getRentalOptionsLoading = createSelector(
  getKwikspaceAppState,
  (state) => state.rental.rentalOptionsLoading
);

export const getRentalOptionsError = createSelector(
  getKwikspaceAppState,
  (state) => state.rental.rentalOptionsError
);

export const getCreatedLineItems = createSelector(
  getKwikspaceAppState,
  (state) => state.rental.createdRentalLineItems
);

export const getCreatedLineItemsLoading = createSelector(
  getKwikspaceAppState,
  (state) => state.rental.createRentalLineItemLoading
);

export const getCreatedLineItemsError = createSelector(
  getKwikspaceAppState,
  (state) => state.rental.createRentalLineItemError
);

export const getCreatedLineItemsSuccess = createSelector(
  getKwikspaceAppState,
  (state) => state.rental.createRentalLineItemSuccess
);

export const updateRentalLineItemSuccess = createSelector(
  getKwikspaceAppState,
  (state) => state.rental.updateRentalLineItemSuccess
);

export const updateRentalLineItemLoading = createSelector(
  getKwikspaceAppState,
  (state) => state.rental.updateRentalLineItemLoading
);

export const updateRentalLineItemError = createSelector(
  getKwikspaceAppState,
  (state) => state.rental.updateRentalLineItemError
);